<template>

  <div class="content-wrap">
    <div class="register-wrap">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3" @click="openModal('companyReg')">
            <ElLabel name="회사명" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="cmpNmRef" v-model="state.managerParams.cmp_nm"/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <ElLabel name="사업부명">
              <template #end="{id}">
                <div class="input-group mb-3" @click="openModal('companyReg')">
                  <ElInput :id="id" v-model="state.managerParams.cmp_dvsn_nm" readonly/>
                  <ElButton  type="s-search"></ElButton>

                </div>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이름" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="usrNmRef" v-model="state.managerParams.mngr_nm" @update:modelValue="getNameMask" :maxlength="10"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="직급" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="positionRef" v-model="state.managerParams.postion" @update:modelValue="getNameMask" :maxlength="10"/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="부서">
              <template #end="{id}">
                <ElInput :id="id" ref="departNmRef" v-model="state.managerParams.depart_nm" @update:modelValue="getNameMask" :maxlength="10"/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="유선번호">
              <template #end="{id}">
                <ElInput :id="id" ref="telRef" v-model="state.managerParams.tel_no" @update:modelValue="getTeleMask" :maxlength="13"/>
              </template>
            </ElLabel>


          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="휴대폰번호" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="mobileRef" 
                  phoneNumber
                  :modelValue="state.managerParams.mobile" 
                  @update:modelValue="getMobileMask"
                  :maxlength="13" />
              </template>
            </ElLabel>


          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이메일" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="emailRef" v-model="state.managerParams.email" :maxlength="50"/>
              </template>
            </ElLabel>


          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">Keyman</label>
            <SelectCode cd_gr="YN_CD" @return="(r) => (state.managerParams.keyman_yn = r.cd_id)" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">고객 성향</label>
            <SelectCode cd_gr="TRD_CD" :matchCd="state.managerParams.trend_cd"
              @return="(r) => (state.managerParams.trend_cd = r.cd_id)" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">재/퇴직여부</label>
            <SelectCode chk_ess='Y' :matchCd="state.managerParams.retire_yn" cd_gr="RTR_CD" @return="(r) => (state.managerParams.retire_yn = r.cd_id)" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="마지막 update날짜">
              <template #end="{id}">
                <DatePicker :id="id" :select-date="state.managerParams.fmt_upd_dt" @return="r => state.managerParams.fmt_upd_dt = r" readonly/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">

            <ElLabel name="활성화/비활성화">
              <template #end="{id}">
                <div :id="id" class="radio-btn-toggle d-flex">

                  <ElLabel name="활성화" classNm="btn btn-sm flex-fill">

                    <template #start="slotProp">
                      <ElRadio
                        v-model="state.managerParams.enable_yn"
                        v-bind="{
                          id:slotProp.id,
                          value:'Y',
                          classNm:'btn-check',
                          name:'options-base',
                        }"
                      />
                    </template>

                  </ElLabel>

                  <ElLabel name="비활성화" classNm="btn btn-sm flex-fill">

                    <template #start="slotProp">
                      <ElRadio
                        v-model="state.managerParams.enable_yn"
                        v-bind="{
                          id:slotProp.id,
                          value:'N',
                          classNm:'btn-check',
                          name:'options-base',
                        }"
                      />
                    </template>

                  </ElLabel>
                </div>
              </template>


            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="즐겨찾기">
              <template #end="{id}">
                <ElButton 
                type="bookmarkL"
                :active="state.managerParams.bkmark_yn === 'Y'" 
                @buttonClick="
                  state.managerParams.bkmark_yn == 'Y'
                    ? changeVal('bkmark_yn', 'N')
                    : changeVal('bkmark_yn', 'Y')
                ">
                  즐겨찾기 추가
                </ElButton>
              </template>
            </ElLabel>
            
            <!--  활성화 클래스 btn-active -->
          </div>
        </div>
      </div>

      <div class="row band">
        <div class="col-md-9">
          <div class="mb-3">
            <ElLabel name="메모">
              <template #end="{id}">
                <ElTextarea  
                  :id="id"
                  v-model="state.managerParams.memo"
                  :rows="3" 
                  style="min-height: 11rem"
                />
              </template>
            </ElLabel>
              
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="명함사진등록">
              <template #end="{id}">
                <div class="photo-wrap" :id="id">
                  <div class="photo">
                    <a href="" data-bs-toggle="modal" data-bs-target="#Modal-img">

                      <img :src="state.previewImg" v-if="state.previewImg" />
                      <img v-else src="/images/namecard-none.jpg" />
                    </a>
                  </div>
                  <ElButton type="registPhoto" @buttonClick="openUpload()">
                    사진등록<span class="ic-photo"></span>
                  </ElButton>
                    <ImgUpload ref="imgUploadRef" @returnData="(data) => (state.previewImg = data)"
                      @returnFileList="(r) => getFileInfo(r)" />
                </div>
              </template>
            </ElLabel>
            
          </div>
        </div>
      </div>
    </div>
    <!-- //register-wrap -->

    <div class="text-end py-3">
      <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
      <ElButton type="primary" @buttonClick="validation('T')">
        임시저장
      </ElButton>
      <ElButton type="primary" @buttonClick="router.push('/mp/MMP_AM_001')">
        임시저장함
      </ElButton>
      <ElButton type="primary" @buttonClick="validation('C')">
        등록완료
      </ElButton>
    </div>

    <div class="accordion" id="accordionPanelsStayOpenExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
            첨부파일
          </ElButton>
        </h2>
        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
          <div class="accordion-body accordion-body-register">
            <FileUpload ref="fileUploadRef" @return="(r) => getFileInfo(r)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LeadModal ref="leadModalRef" @return="(r) => getInfo(r)" />

  <ExcelUploadModal ref="excelUploadModalRef" :colDefs="state.excelModalColDefs"/>
  <!-- modal:이미지크게보기 -->
  <div class="modal fade" id="Modal-img" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          
          <div class="modal-body text-center">
            
            <img :src="state.previewImg" v-if="state.previewImg" />
            <img v-else src="/images/namecard-none.jpg" />
          </div>

        </div>
      </div>
    </div> 
</template>

<script setup>
import { reactive, ref } from "vue";
import LeadModal from "@/components/common/modal/LeadModal.vue";
import DatePicker from "@/components/common/DatePicker.vue";
import FileUpload from "@/components/common/FileUpload.vue";
import ImgUpload from "@/components/common/ImgUpload.vue";
import routerCmn from "@/js/vueRouterCmn";
import { useRouter } from "vue-router";
import SelectCode from "@/components/common/SelectCode.vue";
import common from "@/js/common";
import ExcelUploadModal from "@/components/common/modal/ExcelUploadModal.vue";
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()
const router = useRouter();

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { leadList } from "@/api/lead";
import { mngEdit } from "@/api/mng";
const fileUploadRef = ref();
const imgUploadRef = ref();
const leadModalRef = ref();
const excelUploadModalRef = ref();

const cmpNmRef = ref();
const usrNmRef = ref();
const positionRef = ref();
const departNmRef = ref();
const mobileRef = ref();
const emailRef = ref();
const telRef = ref();

const state = reactive({
  managerParams: {
    mng_seq: "",
    cp_seq: "",
    mngr_nm: "",
    postion: "",
    depart_nm: "",
    mobile: "",
    tel_no: "",
    email: "",
    memo: "",
    keyman_yn: "",
    trend_cd: "",
    enable_yn: "Y",
    attch_pic_id: "",
    ss_user_id: "",
    bkmark_yn: "Y",
    retire_yn: "N",
    cmp_nm: "",
    cmp_dvsn_nm: "",
    status: "",
    cmp_info_seq: "",
    tmp_yn: "N",
    profilePath: "",
    attachFileVO: {
      file_seq: "", //추가 된 파일 seq 전송
      del_file_seq: "", // 삭제해야 할 파일 seq 전송
      file_div_id: "10",
    },
  },
  fileSeqList: [],
  delFileList: [], //수정 -> 삭제 첨부파일 seq array
  previewImg: "",
  excelModalColDefs: [
    { header: "회사명", field: "cmp_nm", req: true },
    { header: "사업부명", field: "cmp_dvsn_nm" },
    { header: "이름", field: "mngr_nm", type: 'spec', req: true },
    { header: "직급", field: "postion", req: true },
    { header: "부서", field: "depart_nm"},
    { header: "유선번호", field: "tel_no", type: 'telPhone' },
    { header: "휴대폰번호", field: "mobile", type: 'phone', req: true },
    { header: "이메일", field: "email", type: 'email', req: true },
    { header: "keyman", field: "keyman_yn" },
    { header: "고객성향", field: "trend_cd" },
    { header: "재/퇴직여부", field: "retire_yn" },
    { header: "활성화/비활성화", field: "enable_yn", type: 'yn' },
    { header: "즐겨찾기", field: "bkmark_yn" },
    { header: "메모", field: "memo" },
  ],
  excelModalData: [],
});

//모바일 형식  (010-0000-0000)
const getMobileMask = (mobile) => {
  state.managerParams.mobile = common.phoneFormat(mobile);
  mobileRef.value.input.value = common.phoneFormat(mobile);
};

//유선전화 형식 (지역번호별 분기)
const getTeleMask = (tel_no) => {
  if (tel_no.indexOf("02") == 0) {
    state.managerParams.tel_no = common.teleFormat02(tel_no);
    telRef.value.input.value = common.teleFormat02(tel_no);
  } else {
    state.managerParams.tel_no = common.teleFormat(tel_no);
    telRef.value.input.value = common.teleFormat(tel_no);
  }
};

//이메일 형식
const getEmailMark = (data) => {
  if(!common.checkEmail(data)){
    alert("이메일 형식을 확인해주세요")
    return false
  }else{
    state.managerParams.email
  }
};

//특수문자
const getNameMask = (data) => {
  if (data != undefined && data != "") {
    if (
      state.managerParams.mngr_nm ||
      state.managerParams.postion ||
      state.managerParams.depart_nm
    ) {
      state.managerParams.mngr_nm = common.checkSpecChar(
        state.managerParams.mngr_nm
      );
      usrNmRef.value.input.value = state.managerParams.mngr_nm

      state.managerParams.postion = common.checkSpecChar(
        state.managerParams.postion
      );
      positionRef.value.input.value = state.managerParams.postion

      state.managerParams.depart_nm = common.checkSpecChar(
        state.managerParams.depart_nm
      );
      departNmRef.value.input.value = state.managerParams.depart_nm

    }
  }
};

//모달에서 값 받아오기
const getInfo = (r) => {
  state.managerParams.cmp_nm = r.cmp_nm;
  state.managerParams.cp_seq = r.cp_seq;
  state.managerParams.cmp_dvsn_nm = r.cmp_dvsn_nm;
  state.managerParams.cmp_info_seq = r.cmp_info_seq;
};

const changeVal = (key, val) => {
  state.managerParams[key] = val;
};

//업로드 파일 저장 후 실행되는 함수
const getFileInfo = (res) => {
  if (res && res?.length > 0) {
    //프로필일 경우

    if (res[res.length - 1].up_path == "/manager/profile") {
      state.managerParams.attch_pic_id = res[res.length - 1].file_seq;
      state.fileSeqList.push(res[res.length - 1].file_seq);
    } else {
      //첨부파일 경우
      res.map((file) => {
        state.fileSeqList.push(file.file_seq);
      });
    }

    regManger()
  }
};

//프로필 첨부하기
const openUpload = () => {
  imgUploadRef.value.clickInput();
};

//모달open 함수
const openModal = async (modal) => {
  if (modal == "upload") {
    try {
      setIsLoading(true)
      let params = {
        page_count: 1,
        unit_count: 100000,
      };
      const res = await leadList(params)
      state.excelModalData = res.rtn;
      excelUploadModalRef.value.openModal();
    } catch (err) {
      console.log("api error", err);
      alert("매니저 조회 실패");
    } finally {
      setIsLoading(false)
    }
  } else if ((modal = "companyReg")) {
    leadModalRef.value.openModal();
  }
};



//담당자 등록
const regManger = async (code) => {
  state.managerParams.status = code;

  if (fileUploadRef.value.state.tmpFileList.length > 0) {
    await fileUploadRef.value.uploadFile("manager/file");
    return
  }

  if (imgUploadRef.value.state.tmpImgData.length > 0) {
    await imgUploadRef.value.uploadFile("manager/profile");
    return
  }

  

  try {
    setIsLoading(true)
    if (state.fileSeqList.length > 0) {
      state.managerParams.attachFileVO.file_seq = state.fileSeqList.toString();
    }

    if (state.delFileList.length > 0) {
      state.managerParams.attachFileVO.del_file_seq =
        state.delFileList.toString();
    }

    state.managerParams.ss_user_id = userStore.user.employeeId;

    const res = await mngEdit(state.managerParams)

    if(res.code === '0000'){
      if(state.managerParams.tmp_yn === 'Y'){
        alert("임시저장을 완료했습니다.");
        router.push({
          path : '/sh/MSH_SR_003',
          state : {mng_seq : res.rtn.mng_seq}
        })
        return
      }
      alert("저장을 완료했습니다. 조회페이지로 이동합니다.");
      routerCmn.routerPush("/sh/MSH_SR_002");
    }else{
      throw new Error('api response 실패')
    }
  } catch (err) {
    console.log("등록 error", err);
    alert("담당자 등록에러.");
  } finally {
    setIsLoading(false)
  }
};

const validation = (code) => {
  if(code !== 'T' && state.managerParams.enable_yn == "Y"){

    //6개 값에 대한 체크
    let msg = codeStore.getCodeMsg("77777"); // 해당 항목은 필수 입력값입니다.

    if (state.managerParams.cmp_nm.trim() == "") {
      //회사명
      alert(msg);
      cmpNmRef.value.input.focus();
      return
    }

    if (state.managerParams.mngr_nm.trim() == "") {
      //담당자명(이름)
      alert(msg);
      usrNmRef.value.input.focus();
      return
    }

    if (state.managerParams.postion.trim() == "") {
      //직급
      alert(msg);
      positionRef.value.input.focus();
      return
    }


    if (!state.managerParams.mobile.trim()) {
      //휴대폰번호
      alert(msg);
      mobileRef.value.input.focus();
      return
    }

    if(state.managerParams.mobile.trim().length > 13){
      //휴대폰번호 자리수
      alert("휴대폰 번호 자리수를 확인해주세요");
      mobileRef.value.input.focus();
      return
    }

    if (state.managerParams.email.trim() == "") {
      //이메일
      alert(msg);
      emailRef.value.input.focus();
      return
    }
    
    if(getEmailMark(state.managerParams.email.trim()) == false){
      emailRef.value.input.focus();
      return 
    }
  }



  if(confirm('등록하시겠습니까?')){
    state.managerParams.tmp_yn = code === "T" ? "Y" : 'N';
    regManger(code)
  }
};


</script>
